import { walletSlice } from "../slices/wallet";

export const walletActions = walletSlice.actions;